<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
        ></dx-grid>

        <v-dialog persistent v-model="updateDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">{{
                    rowClicked.requestType == "Registration Match"
                        ? rowClicked.requestType + " - " + rowClicked.type
                        : rowClicked.requestType
                }}</v-card-title>
                <div class="font-weight-medium mb-2">
                    {{ rowClicked.accountID }}
                </div>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Name:
                    </div>
                    <div>{{ rowClicked.name }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Hebrew Name:
                    </div>
                    <div>{{ rowClicked.nameH }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Address:
                    </div>
                    <div>{{ rowClicked.address1 }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Phone:
                    </div>
                    <div>
                        {{
                            rowClicked.homePhone +
                                (rowClicked.cellPhone
                                    ? " - " + rowClicked.cellPhone
                                    : "")
                        }}
                    </div>
                </v-layout>
                <div
                    class="font-weight-light pb-2 px-2"
                    style="border: #5cb860 1px solid;"
                >
                    <div style="white-space: pre-line;">
                        {{
                            (
                                (rowClicked.requestType == "Request"
                                    ? "Message: "
                                    : "") + rowClicked.info
                            ).trim()
                        }}
                    </div>
                </div>
                <v-textarea
                    v-model="note"
                    label="Note"
                    class="mt-3"
                    rows="2"
                    outline
                    hide-details
                ></v-textarea>
                <v-select
                    v-model="status"
                    label="Status"
                    class="mt-2"
                    :items="['PENDING', 'COMPLETED']"
                    hide-details
                ></v-select>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn :loading="processing" color="success" @click="save">
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="votingDialog" max-width="1000">
            <voting-master-list-person
                :person="presonInfo"
                :reload="reload"
                :close="closeVotingDialog"
            ></voting-master-list-person>
        </v-dialog>
    </div>
</template>

<script>
import votingMasterListPerson from "./VotingMasterListPerson.vue";

export default {
    components: {
        votingMasterListPerson,
    },
    data: () => ({
        title: "Registration Submission Requests",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",
        processing: false,

        selected: [],
        updateDialog: false,
        rowClicked: {},
        status: "",
        note: "",

        votingDialog: false,
        presonInfo: {},

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                },
                icon: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "mdi-check-circle";
                        case "PENDING":
                            return "mdi-clock";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "success";
                        case "PENDING":
                            return "#fdb400";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            // {
            //     label: "ID",
            //     field: "id",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Name",
                field: "name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "votingStatus",
                label: "Voting Status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Request Type",
                field: "requestType",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Entered On",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.columns.find((c) => c.field == "votingStatus").linkAction = (
            row,
        ) => {
            this.openVotingDialog(row);
        };
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.actions.push({
                text: "Show Completed",
                type: "switch",
                action: this.onShowCompletedChanged,
            });

            this.url = "votingRegistrationSubmissions?includeCompleted=";
        },
        onShowCompletedChanged(value) {
            if (value) {
                this.url =
                    "votingRegistrationSubmissions?includeCompleted=true";
            } else {
                this.url = "votingRegistrationSubmissions?includeCompleted=";
            }

            this.$refs.grid.reloadDataSource(this.url);
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));
            this.status = row.status;
            this.note = row.note;

            if (row.info) {
                this.rowClicked.info = this.removeFirstNewline(row.info);
            }

            this.updateDialog = true;
        },
        removeFirstNewline(str) {
            return str.replace(/^\s*(\r\n|\n|\r)/, "");
        },
        async openVotingDialog(row) {
            if (row.personID == "No Ansl ID") {
                return this.$notify({
                    group: "notification",
                    text: "No Ansl ID",
                    type: "warning",
                });
            }

            this.presonInfo = await this.$http.get(
                "api/applicantStudents/getPersonByID?personID=" + row.personID,
            );

            this.votingDialog = true;
        },
        closeVotingDialog() {
            this.votingDialog = false;
        },
        reload() {
            this.$refs.grid.reloadGrid();
        },
        async save() {
            try {
                this.processing = true;

                this.rowClicked.status = this.status;
                this.rowClicked.note = this.note;

                await this.$http.post(
                    "api/VotingRegistrationSubmissions/save",
                    this.rowClicked,
                );

                this.processing = false;
                this.updateDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.reload();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.accounts-search.container {
    padding-top: 0px;
}
.yg-student-account-match {
    border: 2px solid #4caf50;
}
</style>
